import {DateTime} from 'luxon';

/**
 * @param {number|string|Date|DateTime} value
 * @param {Intl.DateTimeFormatOptions} format
 */
export default function (value, format) {
    if (typeof value === 'number') {
        value = DateTime.fromMillis(value);
    } else if (typeof value === 'string') {
        value = DateTime.fromISO(value);
    } else if (value instanceof Date) {
        value = DateTime.fromJSDate(value);
    } else if (value instanceof DateTime) {

    } else {
        console.warn(`The value must be a number of milliseconds, an ISO 8061 string, an instance of Date or an instance of luxon's DateTime, ${typeof value} given.`);

        return value;
    }
    return value.toLocaleString(format);
}


// WEBPACK FOOTER //
// ./assets/js/filters/dateFormat.js